import type { ExportColumn } from '@/components/ui'
import type { OpenOrderRow } from '../api/types'

/**
 * CSV export column list for Open Orders. Key order here is the default
 * export order. Stable keys — user templates in localStorage reference
 * them. NEVER rename; if a column is retired, the template loader
 * silently drops the stale key on read.
 */
export const COLUMNS: readonly ExportColumn<OpenOrderRow>[] = [
  { key: 'customer', header: 'Customer', value: (r) => r.customer },
  { key: 'po_number', header: 'P.O.#', value: (r) => r.po_number },
  { key: 'po_ln', header: 'PO:LN', value: (r) => r.po_ln },
  { key: 'so_number', header: 'SO #', value: (r) => r.so_number },
  { key: 'line', header: 'Line', value: (r) => r.line },
  { key: 'customer_part_number', header: 'Cust.Part#', value: (r) => r.customer_part_number },
  { key: 'product_name', header: 'Product', value: (r) => r.product_name },
  { key: 'due_on', header: 'Due On', value: (r) => r.due_on },
  { key: 'confirmation_date', header: 'Order Confirmed', value: (r) => r.confirmation_date },
  { key: 'last_revision', header: 'Last Revision', value: (r) => r.last_revision },
  { key: 'ordered', header: 'Ordered', value: (r) => r.ordered },
  { key: 'open', header: 'Open', value: (r) => r.open },
  { key: 'on_hand', header: 'On Hand', value: (r) => r.on_hand },
  { key: 'replenish_on_order', header: 'Replenish', value: (r) => (r.replenish_on_order ? 'Yes' : 'No') },
  { key: 'status', header: 'Status', value: (r) => r.status },
  { key: 'coverage_status', header: 'Coverage', value: (r) => r.coverage_status },
  { key: 'odoo_last_updated', header: 'Last Updated', value: (r) => r.odoo_last_updated },
  { key: 'vendor_po', header: 'Vendor PO', value: (r) => r.vendor_po },
  { key: 'vendor', header: 'Vendor', value: (r) => r.vendor },
  { key: 'po_due', header: 'PO Due', value: (r) => r.po_due },
] as const

export const ALL_COLUMN_KEYS: readonly string[] = COLUMNS.map((c) => c.key)
